import {animate, createTimeline, stagger, splitText, spring, createLayout, onScroll} from 'animejs';

const pulse = {
    translateY: [0,-4,0],
    scale: [1, 1.05, 1],
    direction: 'alternate',
    loop: true,
    easing: 'InOutExpo',
    duration: 3000
};
const createCallback = (animation) => {
    return (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                animation.play();
            }
        });
    };
};

// Why Ben B.
const splitWhyBenBHead = splitText('#why-ben-b-head', { chars: { wrap: 'clip' } });
const animationWhyBenBHead = animate(splitWhyBenBHead.chars, {
    y: ['100%', '0%'],
    duration: 750,
    ease: 'out(3)',
    delay: stagger(50),
    autoplay: false,
});
const animationWhyBenBBody = animate('#why-ben-b-body', {
    opacity: [0, 1],
    duration: 1500,
    easing: 'easeInOut',
    delay: 500,
    autoplay: false,
});
const tlWhyBenB = createTimeline( { autoplay: false})
    .label('start', 0)

    .add('#icon-us-can', {
        opacity: 1,
        x: {
            from: -300
        },
        ease: spring({
            bounce: 0.5,
            duration: 1000
        })
    }, 'start')
    .add('#icon-us-can',
        pulse, 1000)
    .add('#text-us-can', {
        opacity: [0, 1],
    }, 600)

    .add('#icon-lead-time', {
        opacity: 1,
        x: {
            from: 300
        },
        ease: spring({
            bounce: 0.5,
            duration: 1000
        })
    }, 200)
    .add('#icon-lead-time',
        pulse, 1200)
    .add('#text-lead-time', {
        opacity: [0, 1],
    }, 800)

    .add('#icon-300-plus', {
        opacity: 1,
        x: {
            from: -300
        },
        ease: spring({
            bounce: 0.5,
            duration: 1000
        }),
    }, 400)
    .add('#icon-300-plus',
        pulse, 1400)
    .add('#text-300-plus', {
        opacity: [0, 1],
    }, 1000)

    .add('#icon-real-time-logistics', {
        opacity: 1,
        x: {
            from: 200
        },
        ease: spring({
            bounce: 0.5,
            duration: 1000
        })
    }, 600)
    .add('#icon-real-time-logistics',
        pulse, 1600)
    .add('#text-real-time-logistics', {
        opacity: [0, 1],
    }, 800)
;

const options = { threshold: 1 };
const observer1 = new IntersectionObserver(createCallback(animationWhyBenBHead), options);
observer1.observe(document.querySelector('#why-ben-b-head'));

const observer2 = new IntersectionObserver(createCallback(animationWhyBenBBody), options);
observer2.observe(document.querySelector('#why-ben-b-body'));

const observer3 = new IntersectionObserver(createCallback(tlWhyBenB), options);
observer3.observe(document.querySelector('#why-ben-b-icons'));

// Passion & Purpose
const splitPassionAndPurposeHead = splitText('#passion-and-purpose-head', { chars: { wrap: 'clip' } });
const imageContainer = $('#staff-images');
const layout = createLayout(imageContainer[0], {
    duration: 1000,
    ease: 'inOutExpo',
});

const observerPassionAndPurpose = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            $(imageContainer).add('.img-staff').css('opacity', 1);
            layout.update(() => {
                imageContainer.removeClass('row-cols-4');
                imageContainer.addClass('row-cols-3');
            }, {
                delay: stagger([0, 500]),
            });

            animate(splitPassionAndPurposeHead.chars, {
                y: ['100%', '0%'],
                duration: 750,
                ease: 'out(3)',
                delay: stagger(50),
            });

            animate('.passion-and-purpose-body', {
                y: {
                    from: 200,
                    to: 0,
                    delay: 0
                },
                opacity: [0, 1],
                duration: 1500,
                easing: 'outInExpo',
                delay: 750,
            });

            animate('#btn-work-with-us', {
                x: {
                    from: -200,
                    to: 0,
                },
                opacity: [0, 1],
                duration: 500,
                ease: spring({
                    bounce: 0.5,
                    duration: 628
                }),
                delay: 1200,
            });

            observerPassionAndPurpose.unobserve(entry.target);
        }
    });
}, {
    threshold: 1 // Trigger when 60% of the element is visible
});
observerPassionAndPurpose.observe(document.querySelector('#staff-images'));


// Buttons
$('.btn').hover(
    function() {
        // Enter
        let btn = $(this)[0];
        animate(btn, {
            scale: 1.025,
            duration: 300,
            ease: 'out(3)'
        });
    },
    function() {
        // Leave
        let btn = $(this)[0];
        animate(btn, {
            scale: 1.0,
            duration: 400,
            ease: 'out(3)'
        });
    }
);
